export default "__VITE_ASSET__C9lz$WAO__"